import { render, staticRenderFns } from "./UiPostTile.vue?vue&type=template&id=3e30f7b2&"
import script from "./UiPostTile.vue?vue&type=script&lang=js&"
export * from "./UiPostTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports